module.exports = __webpack_public_path__ + "img/eg-1.3655b956.jpg";